import { FormControlLabel, Grid, Radio } from '@material-ui/core';
import React from 'react';

/** Renders a radio option with a cursor that reflects its enabled state. */
export const RadioOptionRhf = ({ value, label, disable = false, style = {}, children = false, radio = <Radio /> }) => {
    const cursor = disable ? 'not-allowed' : 'pointer';

    if (children) {
        return (
            <Grid item>
                <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
                    <Grid item>
                        <FormControlLabel
                            value={value}
                            control={<Radio style={{ cursor }} />}
                            label={label}
                            disabled={disable}
                            style={{ ...style, cursor }}
                        />
                    </Grid>
                    {children && (
                        <Grid item style={{ marginLeft: 30 }}>
                            {children}
                        </Grid>
                    )}
                </Grid>
            </Grid>
        );
    } else {
        return (
            <Grid item>
                <FormControlLabel
                    value={value}
                    control={React.cloneElement(radio, { style: { ...radio.props.style, cursor } })}
                    label={label}
                    disabled={disable}
                    style={{ ...style, cursor }}
                />
            </Grid>
        );
    }
};
